import { render, staticRenderFns } from "./ContactInfomation.vue?vue&type=template&id=5a90ab28&scoped=true"
import script from "./ContactInfomation.vue?vue&type=script&lang=js"
export * from "./ContactInfomation.vue?vue&type=script&lang=js"
import style0 from "./ContactInfomation.vue?vue&type=style&index=0&id=5a90ab28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90ab28",
  null
  
)

export default component.exports